// eslint-disable-next-line max-classes-per-file
import { IActivityConfiguration } from 'app/authoring/interfaces/IActivityComponent';
import { Metamodel } from 'app/model/base/model';
import { ExecutePipelineActivity, ExecutePipelineActivityDuplicate } from 'app/model/pipeline/execute-pipeline.activity';
import { ActivityConfigurations } from 'app/authoring/registries/activity-configurations';

import { Pipeline } from 'shell-models-lib';
import { getActivityUrl } from 'app/shared/utils/links.util';

@ActivityConfigurations.register({})
export class ExecutePipelineActivityConfiguration implements IActivityConfiguration {
    public label = !__IS_FABRIC_DPE__ ? stringResources.ExecutePipelineActivityLabel : stringResources.InvokePipelineActivityLabel;
    public name = !__IS_FABRIC_DPE__ ? 'Execute Pipeline' : 'Invoke pipeline';
    public activityType = Metamodel.modelFor(ExecutePipelineActivity);
    public iconClass = 'svg-i_execute_pipeline_16x16';
    public iconTransform = '';
    public categories = [stringResources.General];
    public supportedInTrident = true;
    public isKnownInPipelineContext = true;
    public docLink = getActivityUrl('executePipeline');

    public createActivity(named: Pipeline): ExecutePipelineActivity {
        const activity = this.activityType.create() as ExecutePipelineActivity;
        activity.pipeline = named;
        return activity;
    }
}

@ActivityConfigurations.register({})
export class ExecutePipelineActivityDuplicateConfiguration extends ExecutePipelineActivityConfiguration {
    public activityType = Metamodel.modelFor(ExecutePipelineActivityDuplicate);
    public label = stringResources.InvokePipelineActivityLabel;
    public iconClass = 'svg-i_execute_pipeline_16x16';
}